/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TicketPromoCodeDetail
 */
export interface TicketPromoCodeDetail {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof TicketPromoCodeDetail
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof TicketPromoCodeDetail
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof TicketPromoCodeDetail
     */
    discountKind: string;
    /**
     * 
     * @type {number}
     * @memberof TicketPromoCodeDetail
     */
    value: number;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof TicketPromoCodeDetail
     */
    maxUses: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketPromoCodeDetail
     */
    usedCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof TicketPromoCodeDetail
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the TicketPromoCodeDetail interface.
 */
export function instanceOfTicketPromoCodeDetail(value: object): value is TicketPromoCodeDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('discountKind' in value) || value['discountKind'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('maxUses' in value) || value['maxUses'] === undefined) return false;
    if (!('usedCount' in value) || value['usedCount'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function TicketPromoCodeDetailFromJSON(json: any): TicketPromoCodeDetail {
    return TicketPromoCodeDetailFromJSONTyped(json, false);
}

export function TicketPromoCodeDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketPromoCodeDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'code': json['code'],
        'discountKind': json['discountKind'],
        'value': json['value'],
        'maxUses': ActorActivityRecordActorUserIdFromJSON(json['maxUses']),
        'usedCount': ApiUserTasksGetPageParameterFromJSON(json['usedCount']),
        'isActive': json['isActive'],
    };
}

export function TicketPromoCodeDetailToJSON(json: any): TicketPromoCodeDetail {
    return TicketPromoCodeDetailToJSONTyped(json, false);
}

export function TicketPromoCodeDetailToJSONTyped(value?: TicketPromoCodeDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'code': value['code'],
        'discountKind': value['discountKind'],
        'value': value['value'],
        'maxUses': ActorActivityRecordActorUserIdToJSON(value['maxUses']),
        'usedCount': ApiUserTasksGetPageParameterToJSON(value['usedCount']),
        'isActive': value['isActive'],
    };
}

